// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".customize-widgets-drawer .section-title{font-weight:800;padding-bottom:10px;text-transform:uppercase}.customize-widgets-drawer .widget-toggles{align-items:flex-start;display:flex;flex-direction:column;gap:.5rem}", ""]);
// Exports
module.exports = exports;
